import { useRef } from "react";
import { FieldArray, FieldArrayRenderProps, useFormikContext } from "formik";
import { Button } from "components/DesignSystem/Button/Button";
import { getCoreRowModel, useReactTable } from "react-table-8.10.7";
import { TableUI } from "components/design/TableUI";
import { createAddDetailsTableColumns } from "./AddDetailsTableColumns";
import { AddBulkCartItem } from "constants/BulkCartAction";

export const createInitialRow = (): AddBulkCartItem => ({
  entity_id: "",
  season: undefined,
  quantity: 1,
  payment_amount: 0,
  bundle: false,
  product_content_type_id: 0,
  product_id: "",
  action: "",
  base_task_key: "",
});

export type BulkCartActionFormValues = {
  rows: AddBulkCartItem[];
};

export const AddDetailsForBulkCartAction = () => {
  const { values, setFieldValue } =
    useFormikContext<BulkCartActionFormValues>();
  const fieldArrayHelpersRef = useRef<FieldArrayRenderProps>(null as any);

  const columns = createAddDetailsTableColumns(
    setFieldValue,
    values.rows,
    (index: number) => fieldArrayHelpersRef.current?.remove(index),
    (index: number, value: AddBulkCartItem) =>
      fieldArrayHelpersRef.current?.replace(index, value)
  );

  const table = useReactTable({
    data: values.rows,
    columns: columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div>
      <p className="t-text-body-sm t-text-text-60 t-mb-6">
        Select the task, fill in the details & action type for each entry. Add
        more tasks if needed.
      </p>

      <FieldArray name="rows">
        {(helpers) => {
          fieldArrayHelpersRef.current = helpers;

          return (
            <>
              <TableUI table={table} />

              <div className="t-mt-6">
                <Button
                  onClick={() => helpers.push(createInitialRow())}
                  type="button"
                  size="small"
                >
                  + Add another task
                </Button>
              </div>
            </>
          );
        }}
      </FieldArray>
    </div>
  );
};
